module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Willkommen":"Willkommen","Events - QR-Code Scanner":"Events - QR-Code Scanner","Katalog Produktbilder":"Katalog - Produktbilder","Keine App-Funktionen verfügbar":"Keine App-Funktionen verfügbar","Für diesen Account sind aktuell keine App-Funktionen freigeschaltet.":"Für diesen Account sind aktuell keine App-Funktionen freigeschaltet."}}')
  delete Component.options._Ctor
}
